import { selectTenantName } from "features/user/userSlice";
import { useSelector } from "react-redux";

export const TenantNameResolver = ({ startText, endText }) => {
    const tenantName = useSelector(selectTenantName);
    return <>{startText} {tenantName} {endText}</>;
}
